module.exports = __webpack_public_path__ + "0708c9b7aa3fb883d77309c3bd581aa7.ttf";